import fetch from '@/plugins/axios'
export default {
	namespaced: true,
	state: {
        customerList: [],
        customerPager: {},
        loading: false, 
	},
	mutations: {
		setState(state: any, { key, data }: any) {
			state[key] = data;
		}
    },
	actions: {
        // 获取客户列表
		async getCustomerList({ commit }: any, params: any) {
			commit('setState',{key:'loading',data: true})
			const res:any = await fetch({
                url: '/admin/custom',
                params
			})
            commit('setState',{key:'customerList',data: res.docs})
			commit('setState',{key:'customerPager',data: {limit: res.limit,total: res.total}})
			commit('setState',{key:'loading',data: false})
        },
        // 修改客户信息
		async modifyCustomer({ commit }: any, params: any) {
			return await fetch({
				url: `/client/customphone/${params.id}`,
				method: 'put',
				data: params.data
			})
		},
		// 删除客户
		async deleteCustomer({ commit }: any, id: string) {
			return await fetch({
				url: `/admin/customphone/${id}`,
				method: 'delete'
			})
		},
		// 导出客户
		async exportCustomer({ commit }: any, params: any) {
			return await fetch({
				url: `/admin/customexport`,
				method: 'get',
				params
			})
		},
	}
}